import React, {PureComponent} from 'react'
import cn from 'classnames'
import injectStyles from "react-jss"
import logo from "../../img/logo_footer.svg"

class Header extends PureComponent {

    render() {
        const {classes} = this.props;

        return <div className={cn(classes.header, 'row')}>
            <div className={classes.topBar}>
                <a className={classes.logoLink} href="https://www.theiconic.com.au" data-ga-category="Header Navigation" data-ga-action="Logo" data-ga-label="Homepage" >
                    <img src={logo} alt="The Iconic" className={classes.logo} />
                </a>
            </div>
        </div>
    }
}

export default injectStyles((theme) => ({
    header: {
        position: 'inherit',
        [theme.breakpoint("laptop")]: {
            position: 'relative'
        }
    },
    topBar: {
        height: 40,
        padding: '0 80px',
        fontSize: theme.convertFromIconicRemValue(1),
        lineHeight: theme.convertFromIconicRemValue(1),
        verticalAlign: 'middle',
        textAlign: 'center',

        [theme.breakpoint('tablet')]: {
            height: 46,
            paddingTop: 22,
            fontSize: theme.convertFromIconicRemValue(1.5),
        },
    },
    logoLink: {
        display: 'inline-block',
        color: theme.colors.white,
        verticalAlign: 'middle',
        padding: `${theme.convertFromIconicRemValue(0.75)} 0`,
        lineHeight: theme.convertFromIconicRemValue(1),
        [theme.breakpoint("tablet")]: {
            padding: `0 0 ${theme.convertFromIconicRemValue(0.75)}`,
            lineHeight: theme.convertFromIconicRemValue(1.5)
        },
    },
    logo: {
        width: 'auto',
        height: 14,
        [theme.breakpoint("tablet")]: {
            height: 18.8,
        },
    },
}))(Header)



// WEBPACK FOOTER //
// ./src/components/UniversalNav/Header.js